import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { QuestionFilterComponent } from './question-filter.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [QuestionFilterComponent],
  imports: [
    CommonModule, 
    FormsModule,
    BsDropdownModule.forRoot()
  ],
  exports: [QuestionFilterComponent]
})
export class QuestionFilterModule {}
